import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import PublisherApiService from '../../ApiServices/PublisherApiService/PublisherApiService';
import { useAuth } from '../Auth/AuthContext';
import { toast } from 'react-toastify';
import { Loader2, Globe, X, Check } from 'lucide-react';

const WebsiteForm = ({ item, onSubmit, onCancel, publishers }) => {
  debugger
  const [loading, setLoading] = useState(false);
  const { authState } = useAuth();
  const isAdmin = authState.roles === "Admin";

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      url: '',
      userId: ''
    }
  });



  // Normalize incoming item to match camelCase form fields
  useEffect(() => {
    if (item) {
      reset({
        name: item.name || item.Name || '',
        url: item.url || item.Url || '',
        userId: item.userId || item.UserId || ''
      });
    }
  }, [item, reset]);


  const handleFormSubmit = async (data) => {
  setLoading(true);
  try {
    debugger
    // If not admin, force userId from auth state
    if (!isAdmin) {
      data.userId = authState.user.id;
    }

    // Attach websiteId if editing
    if (item?.websiteId || item?.WebsiteId) {
      data.websiteId = item.websiteId || item.WebsiteId;
    }

    await onSubmit(data);
  } catch (error) {
    toast.error("Failed to save website");
  } finally {
    setLoading(false);
  }
};


  return (
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-2xl border border-gray-200 dark:border-gray-700">

      <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-4 text-white">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Globe size={20} />
          {item?.websiteId || item?.WebsiteId ? 'Edit Website' : 'Add New Website'}
        </h2>
      </div>

      <form onSubmit={handleSubmit(handleFormSubmit)} className="p-6">
        {/* Name */}
        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Website Name *</label>
          <input
            {...register("name")}
            className={`w-full px-4 py-2 rounded-lg border ${errors.name ? 'border-red-500' : 'border-gray-300'} dark:bg-gray-700 dark:border-gray-600 dark:text-white`}
            placeholder="Enter website name"
          />
          {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>}
        </div>

        {/* URL */}
        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Website URL *</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">https://</div>
            <input
              {...register("url")}
              className={`w-full pl-16 px-4 py-2 rounded-lg border ${errors.url ? 'border-red-500' : 'border-gray-300'} dark:bg-gray-700 dark:border-gray-600 dark:text-white`}
              placeholder="example.com"
            />
            {errors.url && <p className="mt-1 text-sm text-red-600">{errors.url.message}</p>}
          </div>
        </div>

        {/* Publisher (Admin Only) */}
        {isAdmin && (
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Assign Publisher</label>
            <select
              {...register("userId")}
              disabled={loading}
              className="w-full px-4 py-2 rounded-lg border border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="">Select Publisher</option>
              {publishers.map((p) => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
          </div>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <X size={16} className="inline mr-2" />
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {loading ? (
              <>
                <Loader2 size={16} className="animate-spin inline mr-2" />
                Processing...
              </>
            ) : (
              <>
                <Check size={16} className="inline mr-2" />
                {item?.websiteId || item?.WebsiteId ? 'Update' : 'Create'}
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default WebsiteForm;
